module.exports = __webpack_public_path__ + "static/media/download-white.894dba53.svg";